var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIc2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#EFF3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.904 43.1093C33.2704 43.1945 33.3039 43.6743 32.9471 43.7932L30.8405 44.4866C25.5471 46.1932 22.7605 44.7666 21.0405 39.4732L19.3338 34.2066C17.6271 28.9132 19.0405 26.1132 24.3338 24.4066L25.3711 24.063C25.774 23.9296 26.1617 24.332 26.0393 24.7383C25.9272 25.1103 25.8221 25.5064 25.7205 25.9266L24.4138 31.5132C22.9471 37.7932 25.0938 41.2599 31.3738 42.7532L32.904 43.1093Z",
    fill: "#002C8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8929 20.7807L36.6663 20.2607C32.2129 19.2073 29.5596 20.074 27.9996 23.3007C27.5996 24.114 27.2796 25.1007 27.0129 26.234L25.7063 31.8207C24.3996 37.394 26.1196 40.1407 31.6796 41.4607L33.9196 41.994C34.6929 42.1807 35.4129 42.3007 36.0796 42.354C40.2396 42.754 42.4529 40.8073 43.5729 35.994L44.8796 30.4207C46.1863 24.8473 44.4796 22.0873 38.8929 20.7807ZM36.3863 34.274C36.2663 34.7273 35.8663 35.0207 35.4129 35.0207C35.3329 35.0207 35.2529 35.0073 35.1596 34.994L31.2796 34.0073C30.7463 33.874 30.4263 33.3273 30.5596 32.794C30.6929 32.2607 31.2396 31.9407 31.7729 32.074L35.6529 33.0607C36.1996 33.194 36.5196 33.7407 36.3863 34.274ZM40.2929 29.7673C40.1729 30.2207 39.7729 30.514 39.3196 30.514C39.2396 30.514 39.1596 30.5007 39.0663 30.4873L32.5996 28.8473C32.0663 28.714 31.7463 28.1673 31.8796 27.634C32.0129 27.1007 32.5596 26.7807 33.0929 26.914L39.5596 28.554C40.1063 28.674 40.4263 29.2207 40.2929 29.7673Z",
    fill: "#002C8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc2);
export default __webpack_public_path__ + "static/media/ic2.bd524243fd6c46da00ec9a386d5f6777.svg";
export { ForwardRef as ReactComponent };